export const Errors = {
    validationFailedError: 'validation_failed',
    cancellationErrorAlreadyCancelled: 'cancellation_already_expired',
    cancellationErrorCallStore: 'cancellation_call_store',
    cancellationErrorTokenExpired: 'cancellation_token_expired',
    cannotShipToAddressErrorMessage: 'cannot_ship_to_address',
    cityStateZipErrorMessage: 'city_state_zip_invalid',
    cityZipErrorMessage: 'city_zip_invalid',
    emailAddressInvalidMessage: 'email_address_invalid',
    emailAddressRequiredMessage: 'email_address_required',
    externalPaymentError: 'external_payment_error',
    afterpayExternalPaymentError: 'afterpay_external_payment_error',
    firstNameInvalidMessage: 'first_name_invalid',
    firstNameRequired: 'first_name_required',
    generic500Error: 'generic_500',
    genericError: 'generic_error',
    giftCardInformationErrorMessage: 'gift_card_information_error',
    invalidAddressErrorMessage: 'address_invalid',
    lastNameInvalidMessage: 'last_name_invalid',
    lastNameRequired: 'last_name_required',
    maxLengthInvalidMessage: 'max_length_invalid',
    minLengthInvalidMessage: 'min_length_invalid',
    patternInvalidMessage: 'pattern_invalid',
    paymentCurrencyNotMatchingConfigurationErrorMessage:
        'payment_currency_not_matching_configuration',
    upsAddressErrorMessage: 'ups_validation_error',
    giftCardErrorMessage: 'gift_card_error',
    paymentDisabledPaymentMethodErrorMessage: 'payment_disabled_payment_method',
    paymentExceededOrderSkuMaxLimitValueErrorMessage: 'payment_exceeded_order_sku_max_limit_value',
    paymentExceededQuantityValueErrorMessage: 'payment_exceeded_quantity_value',
    paymentExceededTotalValueErrorMessage: 'payment_exceeded_total_value',
    paymentLanguageNotMatchingConfigurationErrorMessage:
        'payment_language_not_matching_configuration',
    paymentMinimumTotalValueErrorMessage: 'payment_minimum_total_value',
    paymentNotInRangeTotalValueErrorMessage: 'payment_not_in_range_total_value',
    paymentProviderErrorMessage: 'payment_provider_error',
    paymentProvider3dsErrorMessage: 'payment_provider_3ds_error',
    paymentRestrictedZipCodeErrorMessage: 'payment_restricted_zip_code',
    phoneValidationErrorMessage: 'phone_validation_error',
    productApoRestrictionErrorMessage: 'restricted_apo_product',
    productsRemovedErrorMessage: 'product_removed_error',
    requiredFieldMessage: 'required_field',
    saveCCPreOrderItemsErrorMessage: 'save_cc_pre_order_items',
    saveCCReplenishmentServiceErrorMessage: 'save_cc_replenishment_service',
    shippingApoRestrictionErrorMessage: 'restricted_apo_address',
    shippingRestrictionErrorMessage: 'restricted_state',
    taxNumberErrorMessage: 'taxNumberErrorMessage',
    validityFieldMessage: 'field_invalid',
    weAreSorryAtThisTimeErrorMessage: 'we_are_sorry_at_this_time',
    clickAndCollectSearchErrorText: 'click_and_collect_search_error',
    geoSearchError: 'geo_search_error',
    salutationRequiredMessage: 'salutation_required',
    birthMonthRequiredMessage: 'birth_month_required',
    birthDayRequiredMessage: 'birth_day_required',
    ageGroupRequiredMessage: 'age_group_required',
    customerLocationRequiredMessage: 'customer_location_required',
    countryCodeRequiredMessage: 'country_code_required',
    storesRequiredMessage: 'stores_required'
};
